var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayPlayback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#5A53DD",
    fillOpacity: 0.27
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_1378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8682 9.80869C11.6061 9.08469 10.5828 9.6778 10.5828 11.1324V21.8666C10.5828 23.3226 11.6061 23.915 12.8682 23.1917L22.2505 17.811C23.5131 17.0867 23.5131 15.9133 22.2505 15.1892L12.8682 9.80869Z",
    fill: "#5A53DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_1378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayPlayback);
export default __webpack_public_path__ + "static/media/play-playback.2dd4a78612879e02a6379a4b33d8d9f2.svg";
export { ForwardRef as ReactComponent };